<mapfre-header [isGuest]="true"></mapfre-header>
<div class="container mapfre-content guest-payment-widget-container">

  <mapfre-card [singleCard]="false"  additionalClasses="guest-payment-widget" additionalSectionClasses="align-top ">
    <div [ngClass]="{'shows':!loading, 'hides':loading}">
        <div id="portalOneContainer" class="portalOneContainer"></div>
    </div>
     <div [ngClass]="{'shows':loading, 'hides':!loading}">
      <mapfre-loading></mapfre-loading>
     </div>
  </mapfre-card>
  <div class="guest-disclaimer-padding">
    <div class="col-526570 margin-top mt24 " [ngClass]="{'col-656565':isAcmic}">
      Refunds will be issued to your last credit/debit card if the refund amount is the same or less than your last payment amount. When the refund amount exceeds your last policy payment amount, you will be presented with other refund options. If you have questions regarding your refund, call
      <ng-container *ngIf="!isAcmic; else acmicPhoneNumber">
        <span class="col-red">
          1-855-627-3737</span>
      </ng-container>
      <ng-template #acmicPhoneNumber>
        <span class="text-underline col-005095 fw-500">
          1-844-295-4500</span>
      </ng-template>.
    </div>
    <div class="col-526570 margin-bottom mb24 margin-top mt4">
      *Amounts displayed may not reflect all recent policy changes or payments.
    </div>
  </div>
</div>
